import { connect, MapStateToProps } from 'react-redux';
import { AppState } from '../../../../types/store';
import { getModuleData } from '../../../selectors/modules';
import { Props } from './ActiveMembers';

type StateProps = Pick<Props, 'deviants'>;
type OwnProps = Omit<Props, keyof StateProps>;

const mapStateToProps: MapStateToProps<StateProps, OwnProps, AppState> = (
  state,
  ownProps
) => {
  const { mostActive: deviants } = getModuleData(state, ownProps.moduleId);
  return {
    deviants,
  };
};

export default connect(mapStateToProps);
